/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

import { getLayoutIsWhiteLabelUrl } from 'src/features/layout/selectors';
import { getMe } from 'src/features/users/state/selectors';

function SEO({ description, lang, meta, title }) {
  const isWhiteLabelUrl = useSelector(getLayoutIsWhiteLabelUrl);
  const userData = useSelector(getMe);
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )
  const metaDescription = description || site.siteMetadata.description

  const [metaTitleTemplate, setMetaTitleTemplate] = useState(((isWhiteLabelUrl && !userData) || userData?.customer?.is_subaccount === true) ? false : true);

  useEffect(() => {
    setMetaTitleTemplate(((isWhiteLabelUrl && !userData) || userData?.customer?.is_subaccount === true) ? false : true);
  }, [isWhiteLabelUrl, userData]);

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={(metaTitleTemplate ? `%s | ${site.siteMetadata.title}` : `%s`)}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
